<div class="position-relative  thin-scroll">

  <div>
    <div class="container-fluid pt-1 mb-3 " *ngIf="createOrEditExtraData">
      <div class="header p-2 my-2 d-flex justify-content-between">

        <app-dynamicInputs [extraAttributeObject]="extraAttributeObject" [entityObjectTypeId]="114"
          [entityType]="'Transaction'" [appTransactionsForViewDto]="appTransactionsForViewDto"
          (extraDataCleared)="onExtraAttributeCleared($event)" (extraDataChanged)="onExtraAttributesChanged($event)">

        </app-dynamicInputs>

      </div>
      <hr class="my-2" />
      <div class="InfoForm pr-3 thin-scroll">
        <div class="row ml-1">

        </div>
      </div>
    </div>




  </div>


  <div *ngIf="!createOrEditExtraData">


    <view-extra-data [appTransactionsForViewDto]="appTransactionsForViewDto"
      (onshowSaveBtn)="onshowSaveBtn($event)" [canChange]="canChange" [isCreateOrEdit]='createOrEditExtraData'
      [extraAttributeObject]="extraAttributeObject">
    </view-extra-data>
  </div>


  <div class="container-fluid pt-1 mb-3 " [ngClass]="createOrEditExtraData ?  'd-block' : 'd-none'">
    <div class="header p-2 my-2 d-flex  justify-content-end pr-3">
      <button class="continuebtn text-center btn float-right" (click)="saveExtra()" *ngIf="!showSaveBtn">
        {{l("Continue")}}
      </button>
      <button *ngIf="showSaveBtn" (click)="cancel();" class="cancelbtn text-center btn ">
        Cancel

      </button>
      <button *ngIf="showSaveBtn" (click)="save();" class="previewbtn text-center btn ">
        Save

      </button>
    </div>
  </div>
</div>